import {
    SOLICITO_NUEVO_PROFESIONAL,
    SOLICITO_NUEVO_PROFESIONAL_EXITO,
    SOLICITO_NUEVO_PROFESIONAL_ERROR
} from '../types';
import clienteAxios from '../config/axios';

/* Solicito datos de la DB */
export function solicitudNuevoProfesionalAction(
    informacion
) {

    return async dispatch => {

        dispatch(
            solicitudNuevoProfesional()
        );


        try {

            const {
                config,
                payload
            } = informacion;


            const {
                data
            } =
                await clienteAxios.post(

                    '/paciente/recibirsolicitudprofesional',

                    payload,

                    config

                );


            dispatch(
                solicitudNuevoProfesionalExito(
                    data
                )
            );


            return {

                ok:
                    true,

                data

            };


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudo enviar la solicitud'
                };


            dispatch(
                solicitudNuevoProfesionalError(
                    mensaje
                )
            );


            return {

                ok:
                    false,

                error:
                    mensaje

            };

        }

    };

}

const solicitudNuevoProfesional = () => ({
    type: SOLICITO_NUEVO_PROFESIONAL,
    payload: true
});

// si logro obtener la informacion de la BD
const solicitudNuevoProfesionalExito = (data) => ({
    type: SOLICITO_NUEVO_PROFESIONAL_EXITO,
    payload: data
});

// si hubo un error
const solicitudNuevoProfesionalError = (msg) => ({
    type: SOLICITO_NUEVO_PROFESIONAL_ERROR,
    payload: msg
});